export default function (files, callback) {
  var preImgs = []
  var tmpFiles = []
  var canvas = document.createElement('canvas')
  var context = canvas.getContext('2d')
  if (files.length > 0) {
    for (var i = 0; i < files.length; i++) {
      if (typeof (files[i].size) !== 'undefined' && files[i].size < 2000000) {
        tmpFiles.push(files[i])
        if (tmpFiles.length === files.length) {
          callback(preImgs, tmpFiles)
        }
      } else {
        var reader = new FileReader()
        reader.onload = function (event, a) {
          var img = new Image()
          img.src = event.target.result
          img.onload = function () {
            var imgType = 'image/png'
            var imgExt = '.png'
            if (this.src.indexOf('data:image/png') === 0) {
              imgType = 'image/png'
              imgExt = '.png'
            }
            if (this.src.indexOf('data:image/jpeg') === 0) {
              imgType = 'image/jpeg'
              imgExt = '.jpg'
            }
            if (this.src.indexOf('data:image/gif') === 0) {
              imgType = 'image/gif'
              imgExt = '.gif'
            }
            var originWidth = this.width
            var originHeight = this.height
            var maxWidth = 800
            var maxHeight = 800
            var targetWidth = originWidth; var targetHeight = originHeight
            if (originWidth > maxWidth || originHeight > maxHeight) {
              if (originWidth / originHeight > maxWidth / maxHeight) {
                targetWidth = maxWidth
                targetHeight = Math.round(maxWidth * (originHeight / originWidth))
              } else {
                targetHeight = maxHeight
                targetWidth = Math.round(maxHeight * (originWidth / originHeight))
              }
            }
            canvas.width = targetWidth
            canvas.height = targetHeight
            context.clearRect(0, 0, targetWidth, targetHeight)
            context.drawImage(img, 0, 0, targetWidth, targetHeight)
            var u = canvas.toDataURL(imgType, 0.7)
            preImgs.push(u)
            canvas.toBlob(function (blob) {
              tmpFiles.push(new File([blob], getRandName() + getRandName() + imgExt, { type: imgType }))
              if (tmpFiles.length === files.length) {
                callback(preImgs, tmpFiles)
              }
            })
          }
        }
        reader.readAsDataURL(files[i])
      }
    }
  } else {
    // eslint-disable-next-line standard/no-callback-literal
    callback([], [])
  }
  
  function getRandName () {
    return Math.floor(65536 * (1 + Math.random())).toString(16).substring(1)
  }
}
